const textoEn = {
  "landin-page-1": "Túnel Emisor Poniente II",
};

export default textoEn;
